// Navigation & turn-by-turn helpers — extracted from legacy-utils.ts

import { hasValue, hasStringValue, hasNumericValue } from './validation';
import { openWebpage } from './dom';
import { getAuthObject, getModuleType } from './auth';
import { App } from '@/services/app-compat';

import { isIOSApp, isAndroidApp, notifyApp } from '@/utils/window-globals';
import { load } from '@/services/loading';
const _w = window as any;

export let _ornaNavigationType: number;

export function getOrnaNavigationTypeWithDefault(): number {
  if (!hasNumericValue(_ornaNavigationType)) {
    _ornaNavigationType = getAuthObject()?.personSettings?.navigationType;
  }
  if (!hasNumericValue(_ornaNavigationType)) {
    _ornaNavigationType = _w.OrnaNavigationType.GOOGLE_MAPS;
  }
  if (_ornaNavigationType === _w.OrnaNavigationType.IN_APP && !isInAppNavigationAvailable()) {
    _ornaNavigationType = _w.OrnaNavigationType.GOOGLE_MAPS;
  }
  return _ornaNavigationType;
}

export function setLocalOrnaNavigationType(navigationType: number): void {
  _ornaNavigationType = navigationType;
}

/**
 * When `address` is given, Google Maps and Waze route to the address text instead of the
 * coordinate: callers pass it when the pin does not reliably locate the address (LOW / AREA).
 * In-app navigation is coordinate-only (the native bridge takes lat/lng).
 */
export function startTurnByTurnNavigationV2(latitude: number, longitude: number, address: string | null = null): void {
  let navigationType: number = getOrnaNavigationTypeWithDefault();
  const hexComma = '%2C';
  const byAddress = hasStringValue(address) && address.trim() !== '';
  if (navigationType == _w.OrnaNavigationType.GOOGLE_MAPS) {
    const destination = byAddress ? encodeURIComponent(address.trim()) : `${latitude}${hexComma}${longitude}`;
    openWebpage(`https://www.google.com/maps/dir/?api=1&destination=${destination}&dir_action=navigate`);
  } else if (navigationType == _w.OrnaNavigationType.WAZE) {
    openWebpage(byAddress
      ? `https://www.waze.com/ul?q=${encodeURIComponent(address.trim())}&navigate=yes`
      : `https://www.waze.com/ul?ll=${latitude}${hexComma}${longitude}&navigate=yes&zoom=17`);
  } else if (navigationType == _w.OrnaNavigationType.IN_APP) {
    startTurnByTurnNavigation(latitude, longitude);
  } else {
    App.showPopupNotification("Navigation type not found. Please change settings.", "error");
  }
}

export function startTurnByTurnNavigation(latitude: number, longitude: number): void {
  if (isIOSApp || isAndroidApp) {
    if (!hasValue(latitude) || !hasValue(longitude)) {
      App.showPopupNotification("Unable to load coordinates of destination.", "error");
      return;
    }
    load.showLoadingScreen();
    notifyApp("turnByTurnNavigation", [latitude.toString(), longitude.toString()]);
  } else {
    App.showPopupNotification("Turn-by-turn navigation feature is available only on iOS and Android.", "error");
  }
}

export function turnByTurnNavigationLoaded(): void {
  load.hideLoadingScreen();
}

export function isInAppNavigationAvailable(): boolean {
  if (!isIOSApp && !isAndroidApp) {
    return false;
  }
  return new Date().getTime() < new Date(2023, 2, 27, 18, 0, 0, 0).getTime();
}

export function goToInProgressScreen(): void {
  const moduleType: string = getModuleType();
  if (!hasStringValue(moduleType)) {
    return;
  }
  if (moduleType === 'cad') {
    window.OrnaReact.navigate.toInProgress('CAD');
  } else if (moduleType === 'mdt') {
    window.OrnaReact.navigate.toInProgress('MDT');
  }
}
